'use strict';

import SearchInput from './searchInput/searchInput.component';
import Tags from './tags/tags.directive';
import Pagination from './pagination/pagination.directive';
import MessageBar from './messageBar/messageBar.directive';
import WarningDialog from './warningDialog/warningDialog.directive';
import Spinner from './spinner/spinner.component';
import LoaderOverlay from './loaderOverlay/loaderOverlay.component';
import Overlay from './overlay/overlay.component';
import Gmap from './gmap/gmap.directive';
import UserLookup from './userLookup/userLookup.directive';
import LocationLookup from './locationLookup/locationLookup.directive';
import LocationStates from './locationStates/locationStates.directive';
import Storybook from './storybook/storybook.component';
import Carousel from './carousel/carousel.directive';
import MeasurementsHistory from './measurementsHistory/measurementsHistory.directive';
import Icon from './icon/icon.directive';
import ItemProgress from './itemProgress/itemProgress.directive';
import Liquid from './liquid/liquid.directive';
import SuccessStripes from './successStripes/successStripes.directive';

export default angular
  .module('maestro.directives.components', [
    SearchInput,
    Tags,
    Pagination,
    MessageBar,
    WarningDialog,
    Spinner,
    LoaderOverlay,
    Overlay,
    Gmap,
    UserLookup,
    LocationLookup,
    LocationStates,
    Storybook,
    Carousel,
    MeasurementsHistory,
    Icon,
    ItemProgress,
    Liquid,
    SuccessStripes
  ])
  .name;
